import PropTypes from 'prop-types';
import { FormControl, IconButton, InputLabel, Select } from '@material-ui/core';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';
import makeStyles from '@material-ui/core/styles/makeStyles';
import './ConditionalCustomDate.css';
import React from 'react';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    '&:hover': {
      color: theme.palette.primary.main,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.accent.main
      }
    }
  },
  selectInput: {
    padding: '10px'
  }
}));

const CustomDatePickerHeader = ({ date, changeYear, increaseYear, decreaseYear, years }) => {
  const classes = useStyles();
  return (
    <div
      style={{
        margin: 10,
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center'
      }}
    >
      <IconButton
        disabled={date.getFullYear() === years[0]}
        disableRipple
        aria-label="delete"
        onClick={decreaseYear}
        className={classes.margin}
        size="medium"
      >
        <ArrowLeft fontSize="inherit" color="primary" />
      </IconButton>
      <FormControl variant="outlined">
        <InputLabel htmlFor="quarter-year-select">Year</InputLabel>
        <Select
          value={date.getFullYear()}
          defaultValue={date.getFullYear()}
          native
          onChange={({ target: { value } }) => {
            changeYear(value);
          }}
          className={classes.selectRoot}
          classes={{ select: classes.selectInput }}
          label="Choose..."
          inputProps={{ id: 'quarter-year-select' }}
        >
          {years.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </FormControl>
      <IconButton
        disabled={date.getFullYear() === years[years.length - 1]}
        disableRipple
        aria-label="delete"
        onClick={increaseYear}
        className={classes.margin}
        size="medium"
      >
        <ArrowRight fontSize="inherit" color="primary" />
      </IconButton>
    </div>
  );
};

CustomDatePickerHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  changeYear: PropTypes.func.isRequired,
  increaseYear: PropTypes.func.isRequired,
  decreaseYear: PropTypes.func.isRequired,
  years: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default CustomDatePickerHeader;
